import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import Banner2 from "../components/Banner2"
import AboutServices from "../components/AboutServices"
import Address from "../components/Address"

export default function products() {
  return (
    <Layout>
      <SEO
        title="Advogados Especialistas em Direito Criminal"
        lang="en"
        description="Escritório de Advocacia Especializada em Direito Criminal.Lei Maria da Penha.Habeas Corpus.Garanta seus Direitos!Advogado Criminal em Goiânia-Go"
      />
      <Banner2 autofocus />
      <AboutServices />
      <Address />
    </Layout>
  )
}
